import DOMPurify from "dompurify";
import axiosInstance from "../../utils/axios";

const enabledStatus = 0;
const disabledStatus = 1;

const requireSuccess = (response) => {
  if (!response || !Number.isInteger(response.status) || response.status < 200 || response.status >= 300) {
    throw new Error("Broadcast request failed");
  }
  return response.data;
};

const isBroadcast = (broadcast) => Boolean(
  broadcast && Number.isInteger(broadcast.id) && broadcast.id >= 0 &&
  (broadcast.status === enabledStatus || broadcast.status === disabledStatus) &&
  (broadcast.name == null || typeof broadcast.name === "string") &&
  (broadcast.content == null || typeof broadcast.content === "string")
);

const apiId = (id) => {
  const value = Number(id);
  if ((typeof id !== "string" && typeof id !== "number") ||
    (typeof id === "string" && !id.trim()) ||
    !Number.isInteger(value) || value < 0 || value > 2147483647) {
    throw new Error("Invalid broadcast ID");
  }
  return value;
};

export const listBroadcasts = async () => {
  const broadcasts = requireSuccess(await axiosInstance.get("/Admin/broadcasts"));
  if (!Array.isArray(broadcasts) || !broadcasts.every(isBroadcast)) {
    throw new Error("Unexpected broadcasts response");
  }
  return broadcasts.map((broadcast) => ({
    id: String(broadcast.id),
    title: broadcast.name || "",
    message: DOMPurify.sanitize(broadcast.content || ""),
    createdAt: typeof broadcast.createdOn === "string" && Number.isFinite(Date.parse(broadcast.createdOn)) ? broadcast.createdOn : null,
    enabled: broadcast.status === enabledStatus,
  })).sort((first, second) => (Date.parse(second.createdAt) || 0) - (Date.parse(first.createdAt) || 0));
};

export const sendBroadcast = async ({ title, message }) => {
  const now = new Date().toISOString();
  let auditUser = null;
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const identity = user?.id ?? user?.userName ?? user?.email;
    if (typeof identity === "string" || typeof identity === "number") auditUser = String(identity);
  } catch {
  }
  requireSuccess(await axiosInstance.post("/Admin/AddBroadCast", {
    id: 0,
    name: title.trim(),
    content: DOMPurify.sanitize(message),
    createdOn: now,
    createdBy: auditUser,
    updatedOn: now,
    updatedBy: auditUser,
    status: enabledStatus,
  }));
};

export const setBroadcastEnabled = async (id, enabled) => {
  if (typeof enabled !== "boolean") throw new Error("Invalid broadcast status");
  const numericId = apiId(id);
  const broadcast = requireSuccess(await axiosInstance.get("/Admin/broadcast", { params: { Id: numericId } }));
  if (!isBroadcast(broadcast) || broadcast.id !== numericId) {
    throw new Error("Unexpected broadcast response");
  }
  requireSuccess(await axiosInstance.put("/Admin/UpdateBroadCast", {
    ...broadcast,
    status: enabled ? enabledStatus : disabledStatus,
  }));
};

export const deleteBroadcast = async (id) => {
  requireSuccess(await axiosInstance.delete(`/Admin/deleteBroadCast/${apiId(id)}`));
};
